module.exports = __webpack_public_path__ + "img/pr-4.de376ab4.png";